import { Newspaper, Unlink } from "@wix/wix-ui-icons-common";
import React from "react";
import { RICOS_ANCHOR_TYPE, RICOS_LINK_TYPE } from "./../ricos-content/index.js";
import { LINK_MODAL_ID } from "./../_shared/link-modal/constants.js";
import { toggleLinkModal } from "./../_shared/link-modal/toggle-link-modal.js";
import { PLUGIN_TOOLBAR_BUTTON_ID } from "./../editor-common/index.js";
import {
  alwaysVisibleResolver,
  getAnchorLinkData,
  getUrlLinkData,
  isTextContainsAnchorResolver,
  isTextContainsLinkResolver
} from "./../toolbars-v3/index.js";
import { isLinkPreviewEnabled } from "./../toolbars-v3/resolvers/tiptapResolvers.js";
import {
  LINK_PLUGIN_DISPLAY_AS_LINK_PREVIEW_BUTTON,
  LINK_PLUGIN_REMOVE_BUTTON,
  LINK_PLUGIN_SCROLL_TO_ANCHOR_BUTTON,
  LINK_PLUGIN_WEB_LINK_BUTTON
} from "./data-hooks.js";
import { AnchorLinkButton } from "./toolbar/anchor-link-button.js";
import { DisplayLinkPreview } from "./toolbar/display-link-preview-button.js";
import { RemoveLinkButton } from "./toolbar/remove-link-button.js";
import { UrlLinkButton } from "./toolbar/url-link-button.js";
const getToolbarButtons = (_config, services) => {
  const {
    modals,
    context: { isMobile }
  } = services;
  return [
    {
      id: "anchorLink",
      type: "toggle",
      dataHook: LINK_PLUGIN_SCROLL_TO_ANCHOR_BUTTON,
      attributes: {
        visible: isTextContainsAnchorResolver,
        selectedAnchorLinkData: getAnchorLinkData
      },
      command: ({ tiptapEditor, attributes: { selectedAnchorLinkData } }) => {
        tiptapEditor.commands.scrollToAnchor(selectedAnchorLinkData);
      },
      renderer: (toolbarItem) => /* @__PURE__ */ React.createElement(AnchorLinkButton, { toolbarItem })
    },
    {
      id: "urlLink",
      type: "toggle",
      dataHook: LINK_PLUGIN_WEB_LINK_BUTTON,
      attributes: {
        visible: isTextContainsLinkResolver,
        selectedUrlLinkData: getUrlLinkData
      },
      renderer: (toolbarItem) => /* @__PURE__ */ React.createElement(UrlLinkButton, { toolbarItem })
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SEPARATOR,
      type: "separator",
      attributes: {
        visible: alwaysVisibleResolver
      }
    },
    {
      id: "displayLinkPreview",
      type: "toggle",
      dataHook: LINK_PLUGIN_DISPLAY_AS_LINK_PREVIEW_BUTTON,
      tooltip: "LinkPanelContainer_DisplayAsLinkPreview",
      icon: Newspaper,
      attributes: {
        visible: isLinkPreviewEnabled
      },
      command: ({ tiptapEditor }) => {
        tiptapEditor.commands.createLinkPreview();
      },
      renderer: (toolbarItem) => /* @__PURE__ */ React.createElement(DisplayLinkPreview, { toolbarItem })
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SETTINGS,
      attributes: {
        active: {
          id: "IS_LINK_SETTINGS_BUTTON_ACTIVE",
          resolve: (_, { modals: modals2 }) => Boolean(modals2.getModal(LINK_MODAL_ID))
        }
      },
      command: ({ publicCommands, referenceElement }) => {
        toggleLinkModal({
          initialValue: publicCommands.getLinkDataInSelection(),
          modalService: modals,
          onSave: (link) => {
            publicCommands.insertDecoration(
              link.anchor ? RICOS_ANCHOR_TYPE : RICOS_LINK_TYPE,
              link
            );
          },
          onUnlink: (link) => {
            publicCommands.deleteDecoration(link.anchor ? RICOS_ANCHOR_TYPE : RICOS_LINK_TYPE);
          },
          referenceElement,
          returnFocusToEditor: true
        });
      }
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SEPARATOR,
      type: "separator",
      attributes: {
        visible: alwaysVisibleResolver
      }
    },
    {
      id: "removeLink",
      type: "toggle",
      dataHook: LINK_PLUGIN_REMOVE_BUTTON,
      tooltip: "LinkPanelContainer_RemoveButton",
      icon: Unlink,
      attributes: {
        visible: isTextContainsLinkResolver
      },
      command: ({ tiptapEditor }) => {
        tiptapEditor.chain().focus().unsetLink().run();
      },
      renderer: (toolbarItem) => /* @__PURE__ */ React.createElement(RemoveLinkButton, { toolbarItem })
    },
    {
      id: "removeAnchor",
      type: "toggle",
      dataHook: LINK_PLUGIN_REMOVE_BUTTON,
      tooltip: "LinkPanelContainer_RemoveButton",
      icon: Unlink,
      attributes: {
        visible: isTextContainsAnchorResolver
      },
      command: ({ tiptapEditor }) => {
        tiptapEditor.chain().focus().unsetAnchor().run();
      },
      renderer: (toolbarItem) => /* @__PURE__ */ React.createElement(RemoveLinkButton, { toolbarItem })
    }
  ];
};
export {
  getToolbarButtons
};
//# sourceMappingURL=get-toolbar-buttons.js.map
